import { LoadingButton } from '@mui/lab'
import { Box, Dialog, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import { IUserProfile } from '../../../types/user'
import { useMutation } from '@tanstack/react-query'
import { FinishIntake } from '../../../services/Cases'
import useSnackbar from '../../../hooks/useSnackbar'
import queryClient from '../../../services/Query'
import query from '../../../constants/queries'

interface IntakeDialogProps {
    user: IUserProfile
    users: IUserProfile[]
    onDialogClose: () => void
}

const IntakeDialog: React.FC<IntakeDialogProps> = ({ user, users, onDialogClose }: IntakeDialogProps) => {
    const [userToFinishIntake, setUserToFinishIntake] = useState('')
    const [loadingButton, setLoadingButton] = useState(false)
    const { openSnackbar } = useSnackbar()

    const finishIntakeMutation = useMutation(FinishIntake, {
        onError: (error: any) => {
            console.error(error, 'error to finish intake')
            setLoadingButton(false)
            openSnackbar('Error to finish intake, please try again.')
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries([query.caseDetail, variables.userId])
            setUserToFinishIntake('')
            setLoadingButton(false)
            onDialogClose()
            openSnackbar('Intake status changed')
        }
    })

    const finishIntake = async () => {
        if (user && user.id && userToFinishIntake) {
            setLoadingButton(true)
            await finishIntakeMutation.mutate({ userId: userToFinishIntake })
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={true}
            sx={{ borderRadius: '50px' }}
            onClose={() => {
                onDialogClose()
            }}
        >
            <Typography sx={{ padding: '24px 24px 0' }} variant="h5" fontSize="18px" letterSpacing="0.17px">
                Finish someone's intake status
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'end',
                    padding: '0 24px 24px'
                }}
            >
                <FormControl sx={{ marginTop: '35px' }} fullWidth>
                    <InputLabel>Finish for</InputLabel>
                    <Select
                        label="Finish for"
                        name="finish-intake"
                        value={userToFinishIntake}
                        onChange={(event) => setUserToFinishIntake(event.target.value)}
                    >
                        {users &&
                            users?.map((user, index) => (
                                <MenuItem value={user.id} key={index}>
                                    {user.full_name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
                <LoadingButton
                    loading={loadingButton}
                    loadingIndicator="Wait…"
                    disabled={userToFinishIntake !== '' ? false : true}
                    sx={{ marginTop: '22px' }}
                    variant="contained"
                    onClick={finishIntake}
                >
                    Finish intake
                </LoadingButton>
            </Box>
        </Dialog>
    )
}

export default IntakeDialog
